export const url = '/hotels';
export const Provider = 'Hotels';
export const TABLE_NAME = 'hotels';
